export const CONTINUE_TEXT = 'Continuar';
export const LOAD_TEXT = 'Cargar';
export const LOAD_TEXT_FILES = 'Cargar archivos';